import { useLayoutEffect, useState } from "react";

/**
 * Mirrors catalogue / recommendations CSS grid column counts.
 * @param {React.RefObject<HTMLElement|null>} containerRef
 * @param {{ catalogLayout?: boolean }} options catalogLayout uses the 4-col ≥1200px override
 */
export function useProductGridColumnCount(containerRef, { catalogLayout = false } = {}) {
    const [columns, setColumns] = useState(2);

    useLayoutEffect(() => {
        const update = () => {
            const width = typeof window !== "undefined" ? window.innerWidth : 0;
            if (width < 600) {
                setColumns(2);
                return;
            }
            if (catalogLayout && width >= 1200) {
                setColumns(4);
                return;
            }
            const containerWidth = containerRef.current?.clientWidth || width;
            const gap = 12;
            const minCell = 180;
            setColumns(Math.max(2, Math.floor((containerWidth + gap) / (minCell + gap))));
        };

        update();
        window.addEventListener("resize", update);
        const el = containerRef.current;
        const observer = el ? new ResizeObserver(update) : null;
        if (el && observer) {
            observer.observe(el);
        }
        return () => {
            window.removeEventListener("resize", update);
            observer?.disconnect();
        };
    }, [containerRef, catalogLayout]);

    return columns;
}
